import angular from 'angular';
import uiRouter from 'angular-ui-router';
import cardBaseComponent from './cardBase.component';

let cardBaseModule = angular.module('food-benefit.cardBase', [
  uiRouter
])

.component('cardBase', cardBaseComponent)

.name;

export default cardBaseModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/userCardList/userCardRow/homeCard/cardBase/cardBase.js